// extracted by mini-css-extract-plugin
var _1 = "Npz1n";
var _2 = "D2F91";
var _3 = "Nb1iY";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
